export const UPDATED = "November 5, 2026";

export const PRIVACY = {
  title: "Privacy Policy",
  intro: "This policy explains what information Sweet Results collects through this website, how we use it and the choices you have. We keep it short and plain because your sexual health is personal.",
  sections: [
    {
      h: "Who we are",
      p: ["Sweet Results ([legal business name and address]) runs this website. You can reach us at support@sweetresults.app."],
    },
    {
      h: "What we collect",
      p: ["We only collect what you choose to give us:"],
      list: [
        "App waitlist: your email address and the role you pick (for example everyday tester or content creator).",
        "AI Nurse chat: the messages you type and the AI's replies, linked to a random chat ID stored in your browser for that visit. We do not ask for your name to use the chat.",
        "Basic technical data such as browser type and pages visited, collected by standard website analytics.",
      ],
    },
    {
      h: "Health information in the AI Nurse",
      p: [
        "What you type into the AI Nurse may describe symptoms or sexual health details. Please don't include your name, phone number or other details that identify you.",
        "Your messages are sent to an AI provider to generate a reply. The AI Nurse gives general education only. It is not medical advice and it does not diagnose.",
      ],
    },
    {
      h: "How we use your information",
      p: [],
      list: [
        "To tell you when the Sweet Results app launches and share related updates.",
        "To answer your questions in the AI Nurse chat.",
        "To run, secure and improve this website.",
      ],
    },
    {
      h: "Booking with our testing partner",
      p: [
        "When you choose to book a test, you leave this site and go to our testing partner's website. Any information you give there is handled by that partner under their own privacy policy, not this one.",
        "The booking link is an affiliate link, which means Sweet Results may earn a commission when you book.",
      ],
    },
    {
      h: "Sharing",
      p: ["We do not sell your personal information. We share it only with service providers who help us run the site (such as hosting and the AI provider), or when the law requires it."],
    },
    {
      h: "How long we keep it",
      p: ["We keep waitlist details until the app launches or until you ask us to remove them. We keep chat messages only as long as needed to run and improve the service. [Add your exact retention period.]"],
    },
    {
      h: "Your choices",
      p: ["You can ask us to see, correct or delete your information, or to remove you from the waitlist, by emailing support@sweetresults.app. Depending on where you live, you may have extra rights under local privacy laws."],
    },
    {
      h: "Age",
      p: ["This website is for adults aged 18 and over. We do not knowingly collect information from anyone under 18."],
    },
    {
      h: "Changes",
      p: ["If we update this policy, we'll change the date at the top of this page."],
    },
  ],
};

export const TERMS = {
  title: "Terms of Service",
  intro: "These terms apply when you use the Sweet Results website. By using the site, you agree to them. If you don't agree, please don't use the site.",
  sections: [
    {
      h: "Not medical advice",
      p: [
        "Sweet Results, including the AI Nurse, provides general sexual health education only. Nothing on this site is medical advice, a diagnosis or treatment, and it does not replace care from a licensed healthcare provider.",
        "If you have symptoms or a possible exposure, schedule an STD test and speak with a clinician. In an emergency, call your local emergency number.",
      ],
    },
    {
      h: "Who can use the site",
      p: ["You must be 18 or older to use this website."],
    },
    {
      h: "The AI Nurse",
      p: ["Replies are generated by artificial intelligence and may be incomplete or wrong. Use them as a starting point for a conversation with a healthcare provider, never as a reason to delay testing or care."],
    },
    {
      h: "Testing and our partner",
      p: [
        "Tests are booked and carried out by our independent testing partner on their website. Sweet Results does not perform tests, issue results or provide medical services. The partner's own terms apply to your booking, test and results.",
        "Our booking link is an affiliate link, and Sweet Results may earn a commission when you book.",
      ],
    },
    {
      h: "$10 coupon and $10 rebate",
      p: ["Sweet Results offers $10 off a booking and a $10 rebate per completed test. [Add your eligibility rules, how to claim, how and when rebates are paid, limits per person, and when the offer can end.] We may change or end these offers at any time, but rebates already earned under the rules in place at the time will be honoured."],
    },
    {
      h: "Clearance pass",
      p: ["The clearance pass and 14-day calculator on this site are illustrations and reminders only. They are not proof of a test result. Only your official lab result shows your status."],
    },
    {
      h: "Creator partnerships",
      p: ["There is no creator commission program at this time. Creators can join the waitlist to be considered for potential partnerships. Joining does not guarantee a partnership or any payment."],
    },
    {
      h: "Acceptable use",
      p: ["Don't misuse the site, try to break it, scrape it, or use the AI Nurse to create harmful or unlawful content."],
    },
    {
      h: "Limitation of liability",
      p: ["The site is provided “as is”. To the fullest extent allowed by law, Sweet Results is not liable for any loss arising from your use of the site or from relying on information on it."],
    },
    {
      h: "Governing law",
      p: ["These terms are governed by the laws of [your state / country]."],
    },
    {
      h: "Changes",
      p: ["We may update these terms. The date at the top of this page shows the latest version."],
    },
  ],
};
